export const getElementByTitle = (elements, route) => {
    const elementTitle = route.pathname.split('/');
    const lastRouteElem = elementTitle[elementTitle.length - 1];
    return elements.filter(({ title }) => title === decodeURI(lastRouteElem))[0];
};
